//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import { createRoot } from "react-dom/client";
import * as fonts from "~irad/Styling/SoPFonts";
import * as textCodeService from "~base/Services/TextCodeService";
import MainApp from "./MainApp";

textCodeService.initialize(["sv-SE"], ["VisiFinance.*", "SoP.*"]);
fonts.attachCss();

createRoot(document.getElementById("react-main-root")!).render(<MainApp />);
